import ApiClientInterface from "../ApiClientInterface";

class BizApiClient extends ApiClientInterface {
    constructor(bizApiAgent) {
        super();
        this.bizApiAgent = bizApiAgent;
    }

    registerEndpoint = (name, method, path) => {
        const methodEndpointMap = {
            get: (queryParam={}) => {
                return this.bizApiAgent[method](path, queryParam);
            },
            post: (data, queryParam={}) => {
                return this.bizApiAgent[method](path, data, queryParam);
            }
        }
        
        Object.defineProperty(this, name, {
            value: methodEndpointMap[method],
            writable: true,
            configurable: true,
        });
    }
}

export default BizApiClient;